<template>
    <div style="margin: 40px;">
      <el-row class="pcenter" style="flex-flow: row; justify-content: flex-start;">
        <img class="tx" :src="usertx" />
        <div class="pcenter" style="flex-flow: column; align-items: flex-start; margin-left: 20px;">
          <span style="display:flex; justify-content: flex-start;">账号：{{accountinfo}}</span>
          <span style="display:flex; justify-content: flex-start; margin-top: 10px;">注册时间：{{regtime}}</span>
        </div>
      </el-row>
      <el-row class="rowfg pcenter" style="margin-top: 20px; border-top: 1px #ccc dotted;">
        <el-col :span="6"><span style="font-weight: bold;">登录密码</span></el-col>
        <el-col :span="12"><span>安全性高的密码可以使帐号更安全。建议您定期更换密码。</span></el-col>
        <el-col :span="6" class="pcenter selectbtn" style="justify-content: flex-end; color:darkgreen;"><span @click="showchangepwd">变更密码</span></el-col>
      </el-row>
      <el-row class="rowfg pcenter">
        <el-col :span="6"><span style="font-weight: bold;">切换账号</span></el-col>
        <el-col :span="12"><span>安全退出登录，切换其他的账号。</span></el-col>
        <el-col :span="6" class="pcenter selectbtn" style="justify-content: flex-end; color:darkgreen;"><span @click="quit">退出登录</span></el-col>
      </el-row>
      <el-dialog title="账号修改" :visible.sync="vis_admin_pwd" width="30%" style="margin-bottom: 20px;">
          <el-form ref="form"  label-width="120px" style="margin-bottom: 20px;" label-position="left" >
          <el-form-item label="密码">
            <el-input  v-model="ed_pwd" type="password" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item label="确认密码">
            <el-input  v-model="ed_repwd" type="password" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-button class="gibasebtn" @click="savepwd">更新信息</el-button>
          </el-form>
      </el-dialog>
    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'UserBaseInfo',
    data () {
      return {
        usertx: '',
        accountinfo: '',
        ed_username: '',
        ed_pwd: '',
        ed_repwd: '',
        regtime: '',
        vis_admin_pwd: false
      }
    },
    mounted () {
      that = this
      document.title = '账号信息'
      if (localStorage.getItem('userimg') === null || localStorage.getItem('userimg') === '') {
        this.usertx = 'https://sqpro.oss-cn-beijing.aliyuncs.com/admin/img/tx.jpg'
      }
      this.accountinfo = localStorage.getItem('username')
      this.regtime = localStorage.getItem('regtime')
    },
    methods: {
      showchangepwd () {
        this.vis_admin_pwd = true
      },
      savepwd () {
        var adata = {
          id: {Int64: parseInt(localStorage.getItem('accountid')), Valid: true},
          password: this.ed_pwd
        }
        that.$http({
          url: 'https://api.sqnetsoft.cn/account/changepwd',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.vis_admin_pwd = false
              that.$message({
                type: 'success',
                message: '变更成功!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      quit () {
        this.$router.push({path: '/'})
      }
    }
  }
</script>

<style scoped>
  .selectbtn {
    cursor:pointer;
  }
  .tx {
    width:100px;
    height: 100px;
  }

  .rowfg {
    height: 100px;
    border-bottom: 1px #ccc dotted;
  }
</style>



// WEBPACK FOOTER //
// src/components/regedit/UserBaseInfo.vue